import { UitkBadgeProps, UitkBadgeTheme } from 'uitk-react-badge';
import * as React from 'react';
import { UitkIconSize } from 'uitk-react-icons';
import { UitkMarkSize } from 'uitk-react-mark';
import { IconMark } from '../components/common/icon-mark';
import { ActivityBadgeType, ActivityDestinationViewSearch } from '../common/__generated__/api';
import Icon = ActivityDestinationViewSearch.Icon;
import Mark = ActivityDestinationViewSearch.Mark;

export interface UitkBadgePropsWithChildren extends UitkBadgeProps {
  children?: React.ReactNode;
}

function getBadgeTheme(type: ActivityBadgeType) {
  switch (type) {
    case ActivityBadgeType.DEAL_MEMBER:
      return UitkBadgeTheme.DEAL_MEMBER;
    case ActivityBadgeType.DEAL_GENERIC:
      return UitkBadgeTheme.DEAL_GENERIC;
    case ActivityBadgeType.DEAL_ADD_ON:
      return UitkBadgeTheme.DEAL_BUNDLED;
    default:
      return UitkBadgeTheme.DEAL_GENERIC;
  }
}

function getMediaElement(icon?: Icon | null, mark?: Mark | null): JSX.Element {
  return (
    <IconMark
      mark={mark}
      icon={icon}
      defaultIconSize={UitkIconSize.EXTRA_SMALL}
      markSize={UitkMarkSize.EXTRA_SMALL}
      className={mark ? 'uitk-badge-mark' : 'uitk-badge-icon'}
    />
  );
}

export function getBadgeProps(
  type: ActivityBadgeType,
  icon?: Icon | null,
  mark?: Mark | null,
  badgeText?: string | null,
  styleClasses?: string | null
): UitkBadgePropsWithChildren {
  let props: UitkBadgePropsWithChildren = {
    theme: getBadgeTheme(type)
  };

  if (icon || mark) {
    props = {
      ...props,
      children: getMediaElement(icon, mark)
    };
  }

  if (badgeText) {
    props = {
      ...props,
      text: badgeText
    };
  }

  if (styleClasses) {
    props = {
      ...props,
      className: styleClasses
    };
  }

  return props;
}
